export default __webpack_public_path__ + "static/media/012-sleep well.f197c4f8.svg";